import axios from "axios";
import { API_URL } from "../constants";

export async function setUserAvatar(companyId: string, userId: string, fileId: string) {
  const res = await axios.patch(
    `${API_URL}/${companyId}/users/${userId}/avatar`,
    { fileId }
  );
  return res.data as { avatarFileId: string };
}

export async function deleteUserAvatar(companyId: string, userId: string) {
  const res = await axios.delete(`${API_URL}/${companyId}/users/${userId}/avatar`);
  return res.data;
}

export function getUserAvatarUrl(companyId: string, fileId: string) {
  return `${API_URL}/${companyId}/files/download/${fileId}?mode=view`;
}

export interface AvailableAvatar {
  companyId: string;
  companyName: string;
  fileId: string;
}

export async function fetchAvailableAvatars(companyId: string, userId: string) {
  const res = await axios.get(
    `${API_URL}/${companyId}/users/${userId}/available-avatars`
  );
  return (res.data?.avatars || []) as AvailableAvatar[];
}

export async function importAvatarFromCompany(
  companyId: string,
  userId: string,
  fromCompanyId: string
) {
  const res = await axios.post(
    `${API_URL}/${companyId}/users/${userId}/avatar/import`,
    { fromCompanyId }
  );
  return res.data as { avatarFileId: string };
}
